import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div
            className="cursor-pointer group bg-[#1A1A1A] border border-[#2A2A2A] hover:border-[#FF6B35] transition-all duration-300"
            onClick={() => navigate(`/template2/product/${product.id}`)}
        >
            {/* Image Container */}
            <div className="relative aspect-[3/4] overflow-hidden">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />

                {/* Badge */}
                {product.badge && (
                    <span className="absolute top-2 left-2 md:top-3 md:left-3 bg-[#FF6B35] text-white text-[10px] md:text-[11px] font-bold px-2 py-1 md:px-3 uppercase tracking-wider font-['Montserrat']">
                        {product.badge}
                    </span>
                )}

                {/* Wishlist Button */}
                <button
                    onClick={(e) => { e.stopPropagation(); }}
                    className="absolute top-2 right-2 md:top-3 md:right-3 w-8 h-8 md:w-9 md:h-9 rounded-full flex items-center justify-center md:opacity-0 md:group-hover:opacity-100 transition-all duration-300 bg-[#0A0A0A]/80"
                >
                    <Heart className="w-4 h-4 text-[#A3A3A3]" />
                </button>

                {/* Quick Add */}
                <div className="absolute bottom-0 left-0 right-0 p-2 md:p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <button
                        onClick={(e) => { e.stopPropagation(); }}
                        className="w-full py-2 md:py-2.5 text-xs font-semibold uppercase tracking-wider bg-[#FF6B35] text-white hover:bg-[#E85D26] transition-colors font-['Montserrat'] flex items-center justify-center gap-2"
                    >
                        <ShoppingCart className="w-3.5 h-3.5" />
                        Add to Cart
                    </button>
                </div>
            </div>

            {/* Product Info */}
            <div className="p-3 md:p-4">
                <h3 className="text-xs md:text-sm font-medium text-white line-clamp-1 mb-1 md:mb-1.5 group-hover:text-[#FF6B35] transition-colors font-['Montserrat']">
                    {product.name}
                </h3>
                <div className="flex items-center gap-2">
                    <p className="text-xs md:text-sm font-bold text-[#FF6B35] font-['Montserrat']">
                        {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                    </p>
                    {product.originalPrice && (
                        <p className="text-xs text-[#525252] line-through font-['Montserrat']">
                            {typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
